import { render, staticRenderFns } from "./cms-list.vue?vue&type=template&id=4a651e22&scoped=true&"
import script from "./cms-list.vue?vue&type=script&lang=js&"
export * from "./cms-list.vue?vue&type=script&lang=js&"
import style0 from "./cms-list.vue?vue&type=style&index=0&id=4a651e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a651e22",
  null
  
)

export default component.exports